import { DeleteIcon, EditIcon, ResourceMenuActions } from '@all-manager/design-system-v2';
import { DisplayedMeeting } from '../../types';
import { CreateUpdateMeetingModal } from '../modals/CreateUpdateMeetingModal';
import { DeleteMeetingModal } from '../modals/DeleteMeetingModal';
import { useMeetingMenuAction } from './useMeetingMenuAction';

type Props = {
  meeting: DisplayedMeeting;
  /** Spoken name of the meeting, e.g. "Réunion CS du 22 octobre 2026". */
  name: string;
};

export default function MeetingMenuAction(props: Props) {
  const hook = useMeetingMenuAction();

  return (
    <>
      <ResourceMenuActions
        size="small"
        tooltip={`Options de ${props.name}`}
        actions={[
          {
            id: 'edit',
            label: 'Modifier',
            icon: <EditIcon fontSize="small" />,
            onClick: hook.handleOpenEditModal,
          },
          {
            id: 'delete',
            label: 'Supprimer',
            icon: <DeleteIcon fontSize="small" />,
            onClick: hook.handleOpenDeleteModal,
          },
        ]}
      />

      {hook.isEditModalOpen ? (
        <CreateUpdateMeetingModal meeting={props.meeting} onClose={hook.handleCloseEditModal} />
      ) : null}

      {hook.isDeleteModalOpen ? (
        <DeleteMeetingModal meeting={props.meeting} onClose={hook.handleCloseDeleteModal} />
      ) : null}
    </>
  );
}
